import { useRef, useMemo } from 'react';
import { useElementSize } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { wrapper, container } from './_task.mark-characters.style.js';
import { mapContentToWords } from './util.map-content-to-words.js';
import { mapWordsToElements } from './util.map-words-to-elements.js';
import { jsx } from 'react/jsx-runtime';

function SelectAnswersMarkCharacters(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const contentRef = useRef(null);
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const {
    width
  } = useElementSize(contentRef, {
    applyTo: contentRef,
    axis: "horisontal",
    updateState: true
  });
  const content = useMemo(() => mapWordsToElements(mapContentToWords(props.task.content), {
    isMobile,
    containerWidth: width,
    taskEntryKey: props.taskEntryKey
  }), [isMobile, props.task.content, props.taskEntryKey, width]);
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-context": context,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx("div", {
      className: container,
      children: /*#__PURE__*/jsx("div", {
        ref: contentRef,
        children: content
      })
    })
  });
}

export { SelectAnswersMarkCharacters };
//# sourceMappingURL=_task.mark-characters.js.map
